import React from "react";
import clsx from "clsx";
import DollarIcon from "../../assets/images/dollar-white.svg";
import Spinner from "../DesignSystem/spinner";
import { getDateInShortFormat } from "../../utils/methods";
import LeftArrow from "../../assets/images/left-arrow.svg";

interface PriceBoxProps {
  text: string;
  amount: number | string;
  color: "green" | "blue" | "#304052";
  loading?: boolean;
  date?: Date;
  estimate?: boolean;
  notApplicable?: boolean;
  changeMonthHook?: (_: any) => void;
}

const PriceBox: React.FC<PriceBoxProps> = ({ text, amount, color, loading, date, estimate, notApplicable, changeMonthHook }) => {
  if (notApplicable) return <div className="price-box" />;
  return (
    <div className={clsx("price-box", `box-${color}`)}>
      {changeMonthHook && (
        <div className="arrows left">
          {"<"}
          {/* <img src={LeftArrow} onClick={() => changeMonthHook((prev: number) => prev - 1)} alt="left arrow" style={{ cursor: 'pointer' }} /> */}
        </div>
      )}
      {changeMonthHook && (
        <div className="arrows right">
          {">"}
          {/* <img src={LeftArrow} onClick={() => changeMonthHook((prev: number) => prev + 1)} alt="right arrow" style={{ cursor: 'pointer', transform: 'rotate(180deg)' }} /> */}
        </div>
      )}

      <div className="amount">
        {estimate && <span style={{ paddingRight: "2px" }}>≅</span>}
        <img src={DollarIcon} alt="Dollar" />
        {!loading ? (
          <div>
            <label>{amount}</label>
          </div>
        ) : (
          <div>
            <Spinner size={30} />
          </div>
        )}
      </div>
      <div className="title-root">
        <div className="title">
          <span>{text}</span>
          {date && <span>{`${getDateInShortFormat(date)}`}</span>}
        </div>
      </div>
    </div>
  );
};

export default PriceBox;
